var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.297,
    height: 52.134,
    viewBox: "0 0 55.297 52.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58704",
    "data-name": "Group 58704",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58605",
    "data-name": "Group 58605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159143",
    "data-name": "Path 159143",
    d: "M109.331,165a13.034,13.034,0,1,1-1.607-18.363A13.033,13.033,0,0,1,109.331,165Z",
    transform: "translate(-61.036 -117.523)",
    fill: "#1ad3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159144",
    "data-name": "Path 159144",
    d: "M92.2,142.827a13.033,13.033,0,1,1-1.606-18.362A13.033,13.033,0,0,1,92.2,142.827Z",
    transform: "translate(-64.043 -121.415)",
    fill: "#fbb945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159145",
    "data-name": "Path 159145",
    d: "M108.376,123.178c1.853-1.85,4.423-2.279,5.745-.958l5.986,5.986L76.541,171.77c-1.852,1.851-4.424,2.281-5.747.959l-5.984-5.985Z",
    transform: "translate(-64.81 -121.409)",
    fill: "#985184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectConfig);
export default __webpack_public_path__ + "static/media/projectConfig.381f19eea6c58715542d6124c3a278bd.svg";
export { ForwardRef as ReactComponent };